<template>
    <!--<h1>Documents</h1>-->
    <ListDetailsLayout v-bind:active="active">
        <template slot="list">
            <H1>Hello List</H1>
            <button @click="active=!active">Switch</button>
        </template>

        <template slot="details_laptop">
            <h2>This is my right panel</h2>
        </template>


        <template slot="details_phone">
            <div class="py-3">This is a bottom sheet using the controlled by v-model instead of activator</div>
        </template>


    </ListDetailsLayout>
</template>

<script>

    /*
        human Resources
            -> List members v
                -> detailed view
                    - Person info + profile pic ?
                    - contact address, phone, mail
                    - scholar history
                    - position history
                    - badges (updated documents, active)
            -> Create new   x
                ->
            -> Details
                -> edit
                -> attach UserAccount
                -> add scholar curses
                -> add position
   */
    import ListDetailsLayout from "../../templates/layouts/ListDetailsLayout";
    export default {
        name: "DocumentIndexPage",
        components: {ListDetailsLayout},
        data() {
            return {
                active: false
            }
        }
    }
</script>
